import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const StoreFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 4H4v2h16zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6zm-9 4H6v-4h6z"
      fill="currentColor"
    />
  </svg>
);

StoreFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(StoreFilledIcon);
